// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1W4ym","colMin":"styles_colMin__2IBv7"};